module.exports = __webpack_public_path__ + "static/media/renewable-energy-battery-leaf.68abd1f2.svg";